const Cookies = require('js-cookie')
const eventNames = require('./eventNames')
const standardTracking = require('./standardTracking')

function track(event, props = {}) {
  typeof window !== 'undefined' &&
    window.dataLayer &&
    window.dataLayer.push({
      event,
      ...props,
    })
}

function trackDataLayerLoaded(user = {}, additionalData = {}) {
  track(eventNames.dataLayerLoaded, {
    cookieId: Cookies.get('BRID'),
    userLoggedIn: user.logged_in,
    ...(user?.logged_in ? standardTracking.user(user) : {}),
    ...additionalData,
  })
}

function trackPropertySave(listing, action, additionalData = {}) {
  track(eventNames.propertySave, {
    action,
    status: 'success',
    ...additionalData,
    ...standardTracking.listing(listing),
  })
}

module.exports = {
  eventNames,
  track,
  trackDataLayerLoaded,
  trackPropertySave,
}
